import { ThemeComponent } from "@/theme/ThemeComponent";
import { Component, Ref, SimpleEvent } from '@eastsideco/salvo-ts';
import { SideCart } from "../SideCart/SideCart";
import { debounce } from 'lodash';
@Component
export class CartUpsell extends ThemeComponent {
    @Ref() upsellClose!: HTMLButtonElement;
    private sideCart:SideCart|null = document.body.querySelector('side-cart');

    /**
     * Initialise.
     */
    init() {
        this.setEventListeners();
    }

    /**
     * Set event listeners.
     */
    setEventListeners() {

        // TODO - this should be move to the side cart!

        // if upsell products are not displaying add event listener to check for clicks outside the cart...
        const upsellProducts = document.querySelector('.cart-upsell__products');

        if (upsellProducts != null && upsellProducts?.children?.length == 0) {
            const outer = document.querySelector('.side-cart__outer');
            const cart = document.querySelector('.side-cart');
            outer?.addEventListener('click', (event) => {
                // If the click was inside the side cart, return
                const target  = event.target as HTMLElement;
                if (target?.closest('.side-cart__wrapper')) {
                    return;
                }
                cart?.classList.remove('is-active');
                document.body.classList.remove('drawer-open');
                document.documentElement.classList.remove('drawer-open');
            });
        }

        this.$listen(this.upsellClose, 'click', () => {
            this.classList.remove('is-active');
        });

        if (!this.sideCart) { return; }
        // this.$subscribe(this.sideCart.onOpenChange, debounce(() => {
        //     if (!this.hasAttribute('data-enabled')) { return; }
        //     this.classList.add('is-active');
        // }, 300));

        document.addEventListener('cartClosed', ()=> {
            this.classList.remove('is-active');
        });
    }
}
